import { render, staticRenderFns } from "./frmhozzatartozok.vue?vue&type=template&id=13de2daa&"
import script from "./frmhozzatartozok.vue?vue&type=script&lang=js&"
export * from "./frmhozzatartozok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports